/**
 * Disclaimer Popup — click handler.
 * Visibility is driven by the inline script in the partial (sets
 * `disclaimer-pending` / `disclaimer-accepted` on <html> before paint
 * to avoid FOUC). This module only handles acceptance + dismissal.
 */

const TRANSITION_MS = 250;

const initDisclaimerPopup = () => {
  const popup = document.querySelector('.disclaimer-popup');
  if (!popup) return;
  if (document.documentElement.classList.contains('disclaimer-accepted')) return;

  const frequency = popup.dataset.frequency || 'once';
  const storageKey = popup.dataset.storageKey;
  const storagePrefix = popup.dataset.storagePrefix;

  if (frequency === 'once' && storagePrefix && storageKey) {
    purgeStaleKeys(storagePrefix, storageKey);
  }

  const acceptBtn = popup.querySelector('.disclaimer-popup__accept');
  if (!acceptBtn) return;

  acceptBtn.addEventListener('click', () => {
    if (frequency === 'once' && storageKey) {
      safeSet(storageKey, '1');
    }
    hidePopup(popup);
  });
};

const hidePopup = (popup) => {
  popup.classList.remove('-visible');
  document.documentElement.classList.remove('disclaimer-pending');
  setTimeout(() => {
    popup.remove();
  }, TRANSITION_MS);
};

const safeSet = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    // Silently fail (private mode, quota exceeded).
  }
};

const purgeStaleKeys = (prefix, currentKey) => {
  try {
    const toRemove = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith(prefix) && k !== currentKey) {
        toRemove.push(k);
      }
    }
    toRemove.forEach((k) => window.localStorage.removeItem(k));
  } catch (e) {
    // Ignore.
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDisclaimerPopup);
} else {
  initDisclaimerPopup();
}

export default initDisclaimerPopup;
